<template>
  <b-modal
    id="modal-confirm-product"
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    body-class="modal-confirm-product"
    content-class="modal-confirm-product"
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              v-if="isConfirm"
              icon="check-circle-fill"
              style="color: #4dae89; width: 50px; height: 50px"
            ></b-icon>
            <b-icon
              v-else
              icon="x-circle-fill"
              style="color: #d85a4a; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="6">
            <p
              v-if="isConfirm"
              class="text1-modal-confirm-product confirm-product"
            >
              Tem certeza que deseja adicionar?
            </p>
            <p v-else class="text1-modal-confirm-product cancel-user">
              Tem certeza que deseja cancelar?
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5 mt-3">
          <b-col cols="6">
            <p v-if="isConfirm" class="text2-modal-confirm-product">
              Após a confirmação você <br />
              poderá alterar esse item
            </p>
            <p v-else class="text2-modal-confirm-product">
              As alterações não serão salvas
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="button-modal-confirm-product btn-one-confirm-product"
              @click="$bvModal.hide('modal-confirm-product')"
            >
              <span v-if="isConfirm">VOLTAR</span>
              <span v-else>NÃO</span>
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              v-if="isConfirm"
              class="button-modal-confirm-product btn-two confirm-product"
              type="button"
              @click="responseModal(true)"
            >
              CONFIRMAR
            </button>
            <button
              v-else
              class="button-modal-confirm-product btn-two cancel-user"
              type="button"
              @click="responseModal(false)"
            >
              SIM
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {
    responseModal(isConfirm) {
      this.$emit('responseModalConfirmProduct', isConfirm);
    },
  },
  data() {
    return {
      isConfirm: true,
    };
  },
};
</script>

<style>
.modal-confirm-product {
  background-color: #e8e8e8;
  padding: 8px;
  border-radius: 12px;
  border: none;
}

.text1-modal-confirm-product,
.text2-modal-confirm-product,
.button-modal-confirm-product {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.text1-modal-confirm-product,
.text2-modal-confirm-product {
  text-align: center;
}

.text1-modal-confirm-product {
  font-size: 24px;
  font-weight: 900;
}

.text1-modal-confirm-product.confirm-product {
  color: #4dae89;
}

.text1-modal-confirm-product.cancel-user {
  color: #d85a4a;
}

.text2-modal-confirm-product {
  font-weight: 300;
  font-size: 16px;
  color: black;
}

.button-modal-confirm-product {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.button-modal-confirm-product:focus {
  outline: none;
}

.btn-one-confirm-product {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.btn-two.confirm-product,
.btn-two.cancel-user {
  color: white;
  border: none;
}

.btn-two.confirm-product {
  background-color: #4dae89;
}

.btn-two.cancel-user {
  background-color: #d85a4a;
}
</style>
